import more from '../views/more/Index.vue'
import my from '../views/more/My.vue'
import block from '../views/more/Block.vue'
import play from '../views/play/index.vue'
import coupon from '../views/coupon/index.vue'
import coupon11 from '../views/coupon/doubleeleven.vue'
import cardbag from '../views/coupon/cardbag.vue'
import lucky from '../views/lucky/index.vue'
import turntable from '../views/lucky/turntable.vue'
import login from '../views/user/Login.vue'
import audio from '../views/play/player/audio/audio.vue'
import poster from '../views/more/Poster.vue'
import vip from '../views/vip/index.vue'
import history from '../views/play/history/index.vue'
import off from '../views/play/off.vue'

const commonRouter = [
  {
    path: '/more',
    name: 'more',
    component: more
  },
  {
    path: '/block',
    name: 'block',
    component: block
  },
  {
    path: '/play',
    name: 'play',
    component: play
  },
  {
    path: '/my',
    name: 'my',
    component: my
  },
  {
    path: '/coupon',
    name: 'coupon',
    component: coupon
  },
  {
    path: '/coupon11',
    name: 'coupon11',
    component: coupon11
  },
  {
    path: '/lucky',
    name: 'lucky',
    component: lucky
  },
  {
    path: '/turntable',
    name: 'turntable',
    component: turntable
  },
  {
    path: '/cardbag',
    name: 'cardbag',
    component: cardbag
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/audio',
    name: 'audio',
    component: audio
  },
  {
    path: '/poster',
    name: 'poster',
    component: poster
  },
  {
    path: '/vip',
    name: 'vip',
    component: vip
  },
  {
    path: '/history',
    name: 'history',
    component: history
  },
  {
    path: '/album_off',
    name: 'albumOff',
    component: off
  }
]
export default commonRouter
